
import React from 'react';
import Navbar from '@/components/Navbar';
import StandardFooter from '@/components/layout/StandardFooter';
import { cn } from '@/lib/utils';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}

const PageContainer = ({ children, className }: PageContainerProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className={cn("flex-1 pt-24 px-6 pb-16", className)}>
        <div className="max-w-3xl mx-auto">
          {children}
        </div>
      </main>
      
      <StandardFooter />
    </div>
  );
};

export default PageContainer;
